import React, { useState, useEffect } from 'react'
import { SET_ORDER_BY } from '../../actions/actionTypes'
import { isEqual } from 'lodash'

export default function SortByDropdown({ dispatch, sortByValue, searchTerm }) {
  const [ value, setValue ] = useState(null)

  const onChange = (option) => {
    let orderObj = null

    if ( 'nameAsc' === option ) {
      orderObj = {
        'field': 'name',
        'method': 'asc',
      }
    }
    else if ( 'nameDesc' === option ) {
      orderObj = {
        'field': 'name',
        'method': 'desc'
      }
    }
    else if ( 'newest' === option ) {
      orderObj = {
        'field': 'venue_live',
        'method': 'desc',
      }
    }

    else if ( 'nearest' === option ) {
      orderObj = {
        'field': 'distance',
        'method': 'asc',
      }
    }

    else if ( 'farthest' === option ) {
      orderObj = {
        'field': 'distance',
        'method': 'desc',
      }
    }

    if (orderObj) {
      dispatch({
        type: SET_ORDER_BY,
        payload: {
          value: orderObj,
          dropdownValue: option,
        },
      })
    }

    setValue(option)
  }

  useEffect(() => {
    setValue(sortByValue)
  }, [])

  useEffect(() => {
    if ( (value === 'nearest' || value === 'farthest') && !searchTerm) {
      onChange('newest')
      return
    } 
    if ( !isEqual(value, sortByValue) ) {
        setValue(sortByValue)
      }
    }
  )


  return (
    <div className="c-searchDropdown d-flex align-items-center mr-3">
      <label className="c-searchDropdown__label mb-0 mr-3 text-nowrap">Sort by</label>
      <select onChange={(e) => onChange(e.target.value)} value={value} className="c-searchDropdown__field h-dropdown form-control">
        <option value="newest">Newest</option>
        <option value="nameAsc">Name (asc)</option>
        <option value="nameDesc">Name (desc)</option>
        {
          searchTerm && <>
            <option value="nearest">Distance (Nearest)</option>
            <option value="farthest">Distance (Farthest)</option>
          </>
        }
      </select>
    </div>
  )
}